export default "__VITE_ASSET__8m3_m1ct__"